/**
 * 2007-2018 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2018 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';

// import fontawesome from "@fortawesome/fontawesome";
// import farCalendar from "@fortawesome/fontawesome-pro-regular/faCalendarAlt";
// import farEnvelope from "@fortawesome/fontawesome-pro-regular/faEnvelope";
// import fasArrowUp from "@fortawesome/fontawesome-pro-solid/faArrowUp";
//
// fontawesome.library.add(farCalendar, farEnvelope, fasArrowUp);
// FONT AWESOME ICONS

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './display';

import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';
import './lib/slick.min';

import './components/block-cart';

import { mobileCheck } from './utils';



// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

  // VIDEO MODAL BACKDROP
  
$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();
  initMobieSliders();
  initMobileNavSlider();


  $('#homeVideoModal').on('show.bs.modal', function (e) {
    var video = document.querySelector('#vid1');
    video.play();
    $('body').addClass("videoModal-open");

  }).on('hidden.bs.modal', function (e) {
      $('body').removeClass("videoModal-open");
      var video = document.querySelector('#vid1');
      video.pause();
      $('.modal_video iframe').attr('src', '');
  })

  //vidoeo on cms
  const videos = document.querySelectorAll('.cmsVid');
  if(videos !== null){
    videos.forEach(function(video){
      var hls;
      //HLS supported
        if (Hls.isSupported()) {
          hls = new Hls();
          hls.loadSource(video.src);
          hls.attachMedia(video);
          /*hls.on(Hls.Events.MANIFEST_PARSED,function() {
            //on load hls
            hls.stopLoad();
          });*/
          video.addEventListener('loadedmetadata',function() {
                hls.stopLoad();
          });
        }
        //HLS not supported
        else {
          video.src = video.src;
          video.addEventListener('loadedmetadata',function() {
            video.stop();
          });
        }
      const cmsPlyr = new Plyr(video,{
        controls: ['play-large', 'play', 'mute', 'volume','progress', 'current-time'],
        fullscreen: {enabled: false},
        clickToPlay: false,
      });
      
      video.parentNode.addEventListener("click", event => {
        cmsPlyr.togglePlay();
        event.stopPropagation(); // Necessary or the video will toggle twice => no playback
      });
      if (Hls.isSupported()) {
        cmsPlyr.on('play',function(e){
          hls.startLoad();
        });
      }
    });
    
  }

  //video on before-after page
  var cmsvideo = document.querySelector('#vid2');
  if(cmsvideo !== null){
    //HLS supported
    var hls;
    if (Hls.isSupported()) {
      console.log('hls supported');
      hls = new Hls();
      if(window.innerWidth < 768){
        console.log('mobie vid');
        hls.loadSource('https://web.doczepiane.pl/vid/main-pion/main-pion.m3u8');
      }
      else{
        console.log('desktop vid');
        hls.loadSource('https://web.doczepiane.pl/vid/main/main.m3u8');
      }
      hls.attachMedia(cmsvideo);
      
      cmsvideo.addEventListener('loadedmetadata',function() {
            hls.stopLoad();
      });
      //hls.stopLoad();

    }
    //HLS not supported
    else {
      cmsvideo.src = 'https://web.doczepiane.pl/vid/main-pion/main-pion.m3u8';
     
      cmsvideo.addEventListener('loadedmetadata',function() {
    
      });
    }
    const player = new Plyr(cmsvideo,{
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
      clickToPlay: false,
    });
    cmsvideo.parentNode.addEventListener("click", event => {
        player.togglePlay();
        event.stopPropagation(); // Necessary or the video will toggle twice => no playback
      });
    //close player on video end
    player.on('ended',function(e){
      $('#homeVideoModal').modal('hide');
      hls.stopLoad();
    });
    if (Hls.isSupported()) {
      player.on('play',function(e){
        hls.startLoad();
      });
    }
  }
  
  /*var cmsvideo = document.querySelector('#vid2');
  if(cmsvideo !== null){
  //HLS supported
  var hls;
  if (Hls.isSupported()) {
    console.log('hls supported');
    hls = new Hls();
    if(window.innerWidth < 768){
      console.log('mobie vid');
      hls.loadSource('https://web.doczepiane.pl/vid/main-pion/main-pion.m3u8');
    }
    else{
      console.log('desktop vid');
      hls.loadSource('https://web.doczepiane.pl/vid/main/main.m3u8');
    }
    hls.attachMedia(cmsvideo);

    cmsvideo.addEventListener('loadedmetadata',function() {
          hls.stopLoad();
    });
    hls.stopLoad();
  }
  //HLS not supported
  else {
    cmsvideo.src = 'https://web.doczepiane.pl/vid/main/main.m3u8';
    cmsvideo.addEventListener('loadedmetadata',function() {
            cmsvideo.stop();
          });
    }

  const cmsPlyr = new Plyr(cmsvideo,{
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
    clickToPlay: false,
  });
  cmsvideo.parentNode.addEventListener("click", event => {
    cmsPlyr.togglePlay();
    event.stopPropagation(); // Necessary or the video will toggle twice => no playback
  });
  //close cmsPlyr on video end
  cmsPlyr.on('ended',function(e){
    $('#homeVideoModal').modal('hide');
    hls.stopLoad();
  });
  if (Hls.isSupported()) {
    cmsPlyr.on('play',function(e){
      hls.startLoad();
    });
    cmsPlyr.addEventListener('loadedmetadata',function() {
      hls.stopLoad();
    });
  }else{
    cmsPlyr.addEventListener('loadedmetadata',function() {
      hls.stopLoad();
    });
  }
  }*/

  $(document).on('click', '.text-btn[href="#additionalCatDesc"]', function(e) {
    e.preventDefault();

    const $self = $(this);
    const $target = $($self.attr('href'));

    if($target.hasClass('in')) {
      $self.html($self.attr('data-more'));
      $target.collapse('hide');
    } else {
      $self.html($self.attr('data-close'));
      $target.collapse('show');
    }


  })

$('.slick-cms').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  autoplay: false,
  arrows: true,
  dots: false,
  lazyLoad: 'ondemand',
  responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
        }
      },
    ]
});

  $('.index-featured .products').slick({
    dots: false,
    infinite: true,
    speed: 800,
    autoplay: false,
    arorows: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    lazyLoad: 'ondemand',
    responsive: [
    {
        breakpoint: 1320,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.product-category .products').slick({
    dots: false,
    infinite: true,
    speed: 800,
    autoplay: false,
    arorows: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    lazyLoad: 'ondemand',
    responsive: [
    {
        breakpoint: 1320,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  $('.js-modal-product-images').slick({
    infinite: false,
    arrow: false,
    speed: 800,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('#product div[data-target="#product-modal"]').on('click', function() {
    setTimeout(function(){
      $('.js-modal-product-images').slick('setPosition');
    }, 200)
  });

  if($('body').hasClass('page-index')) {
    $('body').addClass('show-search');
  }

  $('#_mobile_search_toggler').on('click', function() {
    if($('body').hasClass('show-search')) {
      $('body').removeClass('show-search');
    }else {
      $('body').addClass('show-search');
    }
  });


  function initMobieSliders() {
    const isMobile = mobileCheck(992),
          $homeBoxesList = $('.homeBoxes__list'),
          isSliderInitialized = $homeBoxesList.hasClass('slick-slider');

    if(isMobile) {

      if(!isSliderInitialized) {
        $homeBoxesList.slick({
          dots: true,
          infinite: false,
          speed: 600,
          autoplay: false,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          lazyLoad: 'ondemand',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        });
      }

    } else {
      if(isSliderInitialized) {
        $homeBoxesList.slick('unslick');
      }
    }
  }

  $(window).on('resize', initMobieSliders);


  // OFFERT LIST

  $('.offer__list').slick({
    dots: false,
    infinite: true,
    speed: 800,
    autoplay: false,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    lazyLoad: 'ondemand',
    responsive: [
    {
        breakpoint: 1320,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
          infinite: false,
        }
      }
    ]
  });


  function initMobileNavSlider() {
    const isMobile = mobileCheck(480),
          $slider = $('.navInfo');

    if(isMobile) {
      $slider.slick({
        dots: false,
        infinite: true,
        speed: 550,
        autoplay: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false
      });
    }
  }



});
